// import './UserWithdrawHistry.css';
import React, { useState, useEffect } from 'react';
// import './Dashboard.css';
import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, Grid2, IconButton, InputLabel, MenuItem, Modal, Select, TextField, Typography } from '@mui/material';
import Header from '../Header/Header';
import Pagination from '@mui/material/Pagination';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import consts from "../../constant";
import Axios from "axios";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useNavigate } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ToastContainer, toast } from "react-toastify";
import usercalls from "../../Axios";
import ModeTwoToneIcon from '@mui/icons-material/ModeTwoTone';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import CloseIcon from "@mui/icons-material/Close";


const drawerWidth = 260;
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
    justifyContent: "center",
  },
}));


const Asset = () => {
  const [open, setOpen] = React.useState(false);
  // const [result, setResult] = useState([]);
  const navigate = useNavigate()
  const [loader, setloader] = useState(true)
  const [addpage, setaddpage] = useState(false)
  const [netData, setNetData] = useState({});


  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up('lg'));
  const path = usercalls()
  const [openModel1, setOpenmodel1] = useState(false);
  const [contAdd, setContAdd] = useState("");
  const [contAddErr, setContAddErr] = useState("");
  const [networks, setNetworks] = useState([]);
  const [selectedNet, setSelectedNet] = useState("");
  const [selectedNetId, setSelectedNetId] = useState("");
  const [totalPage, setTotalPages] = useState(0)





  const [data, setData] = useState([])

  const getAllAsset = async () => {
    try {
      setloader(true)
      const url = `${consts.BackendUrl}/admin/getallasset`;

      const response = await path.getCallWithToken({ url });

      const result = await response.json();
      console.log(result, 'result');
      if (result?.success) {
        setData(result?.result)
        setTotalPages(Math.ceil(result?.result.length / limit))
        setloader(false)
      }

    } catch (error) {
      console.log(error.message)
    }
  }








  const getNetworks = async () => {
    try {
      setloader(true)
      const url = `${consts.BackendUrl}/admin/networks`
      const resposne = await path.getCallWithToken({ url })
      const result = await resposne.json()
      console.log("44545845454", result?.result)

      if (result?.result.length > 0) {
        setNetworks(result?.result);
        setloader(false);
      }

    } catch (error) {
      console.log("error", error)

    }
  };



  useEffect(() => {
    if (localStorage.getItem("adminToken")) {
      getAllAsset()
      getNetworks()
    }

  }, [limit, page]);

  const tabelHeader = [
    "S.no", "Coin Name",
    "Deposit Status", "Withdraw Status",
    // "Trading Status",
    // "Min Deposit",
    // "Min Withdraw", "Max Withdraw",
    // "Withdraw Charge",
    "Withdraw Type",
    "Is Active",
    "Action"
  ];




  const [selectedValue, setSelectedValue] = useState(null);
  const [formData, setFormData] = useState({
    min_deposit: "",
    min_withdraw: "",
    max_withdraw: "",
    withdraw_commission: "",
    DepositStatus: false,
    WithdrawStatus: false,
    status: false,
    image: "",
    symbol: ""
  });

  // { label: "Min Deposit", name: "min_deposit" },
  // { label: "Min Withdraw", name: "min_withdraw" },
  // { label: "Max Withdraw", name: "max_withdraw" },
  // { label: "Withdraw Commission", name: "withdraw_commission" },
  // { label: "Day Limit", name: "dayLimit" },
  // { label: "Network Id", name: "networkId" },
  // { label: "Coin Id", name: "coinId" },
  // { label: "Wallet Id", name: "walletId" },
  // { label: "Deposit Wallet Id", name: "depositWalletId" },


  const handleOpen = (value) => {
    setSelectedValue(value);
    setFormData({
      id: value?._id,
      min_deposit: value?.min_deposit,
      min_withdraw: value?.min_withdraw,
      max_withdraw: value?.max_withdraw,
      withdraw_commission: value?.withdraw_commission,
      image: value?.image,
      dayLimit: value?.dayLimit,
      networkId: value?.networkId,
      coinId: value?.coinId,
      walletId: value?.walletId,
      depositWalletId: value?.depositWalletId,
      withdrawType: value?.withdrawType,
      coinType: value?.coinType,
      currencyType: value?.currencyType,
    });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedValue(null);
  };

  const handleClose1 = () => {
    setOpenmodel1(false)
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const handleEdit = async (val) => {
    const url = `${consts.BackendUrl}/admin/editasset`;

    const response = await path.postCall({ url, payload: formData });
    const result = await response.json();
    console.log(result, "result");
    if (result?.success) {
      toast.success(result?.message)
      handleClose()
      getAllAsset()
    }
  }


  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const formData = new FormData();
        formData.append("image", file);

        const response = await Axios.post(
          `${consts.BackendUrl}/admin/imageUploadAdmin`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem("adminToken"),
            },
          }
        );

        if (response?.data?.success && response?.data?.result) {
          setFormData((prev) => ({ ...prev, image: response?.data?.result }));
        } else {
          console.error("Failed to upload image. No URL returned.");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };




  const handleNetChange = (network) => {
    setSelectedNetId(network._id);
  };


  const handleAddNetwork = async () => {
    try {

      if (contAdd == "") {
        setContAddErr("Please Enter Address");
      }

      const payload = {
        symbol: netData?.symbol,
        Network_id: selectedNetId,
        Contract_Address: contAdd
      }
      const url = `${consts.BackendUrl}/admin/networktoasset`
      const response = await path.postCall({ url, payload })
      const result = await response.json()
      console.log("5151555", result)
      if (result?.success) {
        toast.success(result?.message)
        handleClose1()
      } else {
        toast.error(result?.message)
      }
    } catch (error) {
      console.log(error, "error adding network");
    }
  };


  return (
    <div className="Asset">
      <ToastContainer />
      <Box sx={{ display: lg ? 'flex' : 'block' }}>
        <Header />
        <Box
          component="main"
          sx={{ flexGrow: 1, p: 5, width: { lg: `calc(100% - ${drawerWidth}px)` }, marginTop: '50px' }}
        >
          <Grid2 container spacing={2}>
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <Button
                variant="contained"
                sx={{ marginLeft: "auto", display: "block", marginTop: "20px" }}
                onClick={() => {
                  navigate(`/${consts.route}/createasset`);
                }}
              >
                Create
              </Button>
              <div className="custom_table">
                <TableContainer >
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        {tabelHeader.map((val, index) => {
                          return (
                            <TableCell align='center'>  {val}</TableCell>
                          )

                        })}

                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {[...data].slice((page - 1) * limit, page * limit)?.map((value, index) => (
                        <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell align='center'>{limit * (page - 1) + index + 1}</TableCell>
                          <TableCell align="center">
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2 }}>
                              {!value?.image ? (
                                <Avatar sx={{ width: 25, height: 25 }}>{value?.symbol?.charAt(0)}</Avatar>
                              ) : (
                                <img style={{ width: "30px", height: "30px" }} src={value?.image} alt={value?.symbol} />
                              )}
                              <span>{value?.symbol}</span>
                            </Box>
                          </TableCell>
                          <TableCell align="center">
                            {value?.depositStatus == 1 ? (
                              <CheckCircleOutlineOutlinedIcon sx={{ fill: "green" }} />
                            ) : (
                              <BlockOutlinedIcon sx={{ fill: "red" }} />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {value?.withdrawStatus == 1 ? (
                              <CheckCircleOutlineOutlinedIcon sx={{ fill: "green" }} />
                            ) : (
                              <BlockOutlinedIcon sx={{ fill: "red" }} />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {value?.withdrawType == 1 ? (
                              <p>Automatic</p>
                              // <CheckCircleOutlineOutlinedIcon sx={{ fill: "green" }} />
                            ) : (
                              <p>Manual</p>
                              // <BlockOutlinedIcon sx={{ fill: "red" }} />
                            )}
                          </TableCell>

                          <TableCell align="center">
                            {value?.isActive == 1 ? (
                              <CheckCircleOutlineOutlinedIcon sx={{ fill: "green" }} />
                            ) : (
                              <BlockOutlinedIcon sx={{ fill: "red" }} />
                            )
                            }</TableCell>


                          {/* <TableCell align="center">{value?.min_deposit}</TableCell>
                          <TableCell align="center">{value?.min_withdraw}</TableCell>
                          <TableCell align="center">{value?.max_withdraw}</TableCell>
                          <TableCell align="center">{value?.withdraw_commission}</TableCell> */}
                          <TableCell align="center">
                            <Button
                              sx={{
                                marginLeft: "10px",
                                backgroundColor: "#1976d2",
                                color: "#fff",
                                '&:hover': { backgroundColor: "#1565c0" },
                                padding: "8px 16px",
                                borderRadius: "8px",
                                fontWeight: "bold",
                              }}
                              variant="contained"
                              onClick={() => handleOpen(value)}
                            >
                              Edit
                            </Button>

                            <Button
                              sx={{
                                marginLeft: "10px",
                                backgroundColor: "#1976d2",
                                color: "#fff",
                                '&:hover': { backgroundColor: "#1565c0" },
                                padding: "8px 16px",
                                borderRadius: "8px",
                                fontWeight: "bold",
                              }}
                              variant="contained"
                              onClick={() => {
                                setNetData(value);
                                setOpenmodel1(!openModel1);
                              }}
                            >
                              Add Network
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>

                    {/* Modal for Editing */}
                    <Modal open={open} onClose={handleClose}>
                      <Box
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: 500,
                          maxHeight: "90vh",
                          bgcolor: "background.paper",
                          boxShadow: 24,
                          p: 4,
                          borderRadius: 2,
                          overflowY: "auto",
                        }}
                      >
                        <Typography variant="h6" gutterBottom>
                          Edit Details
                        </Typography>

                        <DialogContent dividers>
                          <Grid container spacing={2}>
                            <Grid item xs={12} display="flex" alignItems="center" gap={2}>
                              {formData.image && (
                                <img style={{ width: 60, height: 60 }} src={formData.image} alt={formData.symbol || "Uploaded image"} />
                              )}
                              <Button variant="contained" component="label" sx={{ textTransform: "none" }}>
                                Upload File
                                <input type="file" hidden accept="image/*" onChange={handleImageUpload} />
                              </Button>
                            </Grid>

                            {[
                              { label: "Min Deposit", name: "min_deposit" },
                              { label: "Min Withdraw", name: "min_withdraw" },
                              { label: "Max Withdraw", name: "max_withdraw" },
                              { label: "Withdraw Commission", name: "withdraw_commission" },
                              { label: "Day Limit", name: "dayLimit" },
                              { label: "Network Id", name: "networkId" },
                              { label: "Coin Id", name: "coinId" },
                              { label: "Wallet Id", name: "walletId" },
                              { label: "Deposit Wallet Id", name: "depositWalletId" },
                            ].map((field, index) => (
                              <Grid item xs={12} key={index}>
                                <TextField fullWidth margin="normal" label={field.label} name={field.name} value={formData[field.name]} onChange={handleChange} />
                              </Grid>
                            ))}

                            <Grid item xs={12}>
                              <InputLabel id="withdraw-type-label">Withdraw Type</InputLabel>
                              <Select fullWidth name="withdrawType" value={formData?.withdrawType} onChange={handleChange} labelId="withdraw-type-label" displayEmpty>
                                <MenuItem value="" disabled>
                                  Select Withdraw Type
                                </MenuItem>
                                <MenuItem value="0">Manual</MenuItem>
                                <MenuItem value="1">Automatic</MenuItem>
                              </Select>
                            </Grid>

                            <Grid item xs={12}>
                              <InputLabel id="withdraw-type-label">Coin Type</InputLabel>
                              <Select fullWidth name="coinType" value={formData?.coinType} onChange={handleChange} labelId="coinType-label" displayEmpty>
                                <MenuItem value="" disabled>
                                  Select Coin Type
                                </MenuItem>
                                <MenuItem value="0">Coin</MenuItem>
                                <MenuItem value="1">Token</MenuItem>
                              </Select>
                            </Grid>


                            <Grid item xs={12}>
                              <InputLabel id="withdraw-type-label">CurrencyType</InputLabel>
                              <Select fullWidth name="currencyType" value={formData?.currencyType} onChange={handleChange} labelId="currencyType-label" displayEmpty>
                                <MenuItem value="" disabled>
                                  Select currency Type
                                </MenuItem>
                                <MenuItem value="0">Crypto</MenuItem>
                                <MenuItem value="1">Fiat</MenuItem>
                              </Select>
                            </Grid>

                          </Grid>
                        </DialogContent>

                        <Box mt={2} display="flex" justifyContent="space-between">
                          <Button variant="contained" sx={{ backgroundColor: "green", color: "white" }} onClick={() => handleEdit(selectedValue)}>
                            Save
                          </Button>
                          <Button variant="outlined" sx={{ backgroundColor: "red", color: "white" }} onClick={handleClose}>
                            Cancel
                          </Button>
                        </Box>
                      </Box>
                    </Modal>
                  </Table>
                </TableContainer>
                <Pagination className='pagnation'
                  count={totalPage}
                  page={page}
                  onChange={(event, value) => {
                    setPage(value);
                  }}
                  // color='primary'
                  shape="rounded" />
              </div>
            </Grid2>
          </Grid2>
        </Box>
      </Box>

      <BootstrapDialog
        onClose={handleClose1}
        aria-labelledby="customized-dialog-title"
        open={openModel1}
        className="edit-dialogbox"
        sx={{
          "& .MuiDialog-paper": { backgroundColor: "#10212c", color: "#fff", width: "900px", margin: 0 }
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Add Network
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose1}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Grid2
            container
            spacing={0}
            style={{ height: "100%" }}
            alignItems={"center"}
          >
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
              sx={{
                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                  color: "white",
                },

              }}
            >
              <div className="view-inp p-10">
                <div className=" txt-white ">Symbol</div>
                <div className="mt-10">
                  <TextField value={netData?.symbol} id="outlined-basic" variant="outlined" fullWidth />
                </div>
              </div>

              <div className="view-inp p-10">
                <div className="txt-white">Network</div>
                <div className="mt-10">
                  <FormControl fullWidth variant="outlined"
                    sx={{
                      "$& .MuiSelect-color": { color: "white" }
                    }}
                  >
                    <Select
                      sx={{
                        "& .MuiSelect-icon": { color: "white" },
                        "& .MuiSelect-select": { color: "white" },
                      }}
                      labelId="network-label"
                      id="network-select"
                      value={selectedNetId}
                      onChange={(e) => handleNetChange(networks.find(net => net._id === e.target.value))}
                      label="Network"
                    >
                      {networks.length > 0 ? (
                        networks.map((network) => (
                          <MenuItem key={network._id} value={network._id}>
                            {network.Network_name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="" disabled>
                          No Network Found
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </div>
              </div>

              <div className="view-inp p-10">
                <div className=" txt-white ">Contract Address</div>
                <div className="mt-10">
                  <TextField value={contAdd} onChange={(e) => { setContAddErr(""); setContAdd(e?.target?.value) }} id="outlined-basic" variant="outlined" fullWidth />
                </div>
                {contAddErr != "" ? <p style={{ color: "red", textAlign: "center" }}>{contAddErr}</p> : null}
              </div>
            </Grid2>

          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddNetwork} autoFocus variant="contained">
            Add Network
          </Button>
        </DialogActions>
      </BootstrapDialog>

    </div >
  );
};

export default Asset;
